import useSettings from "app/hooks/useSettings";
//import logo from "../../../public/assets/images/payment-methods/logo-Evides.png";
import { ChatAvatar } from "app/components";
export default function NorthernPowerGridLogo({ className }) {
  const { settings } = useSettings();
  const theme = settings.themes[settings.activeTheme];

  // You can customize the styles here based on the theme, for example:
  const logoStyles = {
    width: "180px",
    filter: theme?.logoFilter || "none", // Example: You could apply a filter based on the theme
    borderRadius: theme?.logoBorderRadius || "0px", // Example: Apply border radius if you like
  };

  return <img src="/assets/images/XcelEnergy.png" status="online" />;
}
